import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  getBaseCalendarByUser,
  getSelectedUser,
  getAllUserCalendars,
  getIsLoadingBase,
  getIsLoadingUserCalendars,
  getInitialBaseCalendarByUser,
  getInitialCustomCalendarByUser
} from './store/selectors/calendars.selectors';
import { Subscription, Observable } from 'rxjs';
import { UpdateBaseCalendarUser, SetBaseCalendarUser, UpdateCustomCalendar, SetCustomCalendar, ResetState } from './store/actions/calendars.actions';
import { BzgModalRef, BzgModalService } from 'bz-genome-angular';
import { SavePendingChangesComponent } from 'app/shared/components/save-pending-changes/save-pending-changes.component';
import { selectRequestValidation, selectPendingChangeAction } from 'app/core/store/selectors/pending-changes.selector';
import { pendingChangesAction, RequestPendingChangesDone, ResetProperties, RequestPendingChanges } from 'app/core/store/actions/pending-changes.actions';
import { EPendingChangesSelectedAction } from 'app/core/models/pending-changes.enum';
import { IAppState } from 'app/IAppState';


@Component({
    selector: 'working-time-schema',
    templateUrl: 'working-time-schema.component.html',
    styleUrls: ['working-time-schema.component.scss']
})

export class WorkingTimeSchemaComponent {
    private _baseCalendar: IBaseCalendar;
    private _initialCustomUserCalendar: IWorkingTimeSchema[];
    private _customUserCalendar: IWorkingTimeSchema[];
    private _baseCalendarByUserSubscription: Subscription;
    private _initialBaseCalendar: IBaseCalendar;
    private _hasChangesSubscription: Subscription;
    private _initialBaseCalendarSubscription: Subscription;
    private _selectedUserSubscription: Subscription;
    private _pendingChangesActionSubscription: Subscription;
    private _initialCustomCalendarSubscription: Subscription;
    private _customCalendarSubscription: Subscription;

    public selectedUser: ISpecificUser;
    public modalRef: BzgModalRef;
    public isLoadingBase$: Observable<boolean>;
    public isLoadingUserCalendars$: Observable<boolean>;
    public selectedTab: number = 0;


    constructor(private _store: Store<IAppState>, private _modalService: BzgModalService) {
        this._hasChangesSubscription = this._store.pipe(select(selectRequestValidation)).subscribe((requestingChanges) => {
            const hasChanges =
              !_.isEqual(this._initialBaseCalendar, this._baseCalendar) ||
              !_.isEqual(
                this._initialCustomUserCalendar,
                this._customUserCalendar
              );
            if (!requestingChanges) {
            }
            else if (requestingChanges && hasChanges) {
                this.dialogPendingChanges();
            } else {
                this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.CONTINUE));
                this._store.dispatch(new RequestPendingChangesDone());
            }
        });
        this._baseCalendarByUserSubscription = this._store
          .pipe(select(getBaseCalendarByUser))
          .subscribe(
            (calendar: IBaseCalendar) => (this._baseCalendar = calendar)
          );
        this._initialBaseCalendarSubscription = this._store
          .pipe(select(getInitialBaseCalendarByUser))
          .subscribe(
            (calendar: IBaseCalendar) => (this._initialBaseCalendar = calendar)
          );
        this._initialCustomCalendarSubscription = this._store
          .pipe(select(getInitialCustomCalendarByUser))
          .subscribe((customCalendar: IWorkingTimeSchema[]) => {
            this._initialCustomUserCalendar = customCalendar;
          });
        this._customCalendarSubscription = this._store
          .pipe(select(getAllUserCalendars))
          .subscribe(
            (customCalendar: IWorkingTimeSchema[]) =>
              (this._customUserCalendar = customCalendar)
          );
        this._selectedUserSubscription = this._store.pipe(select(getSelectedUser)).subscribe((user) => this.selectedUser = user);
        this.isLoadingBase$ = this._store.pipe(select(getIsLoadingBase));
        this.isLoadingUserCalendars$ = this._store.pipe(select(getIsLoadingUserCalendars));
    }

    ngOnDestroy() {
        if (this._baseCalendarByUserSubscription) {
            this._baseCalendarByUserSubscription.unsubscribe();
        }
        if (this._initialBaseCalendarSubscription) {
            this._initialBaseCalendarSubscription.unsubscribe();
        }
        if (this._hasChangesSubscription) {
            this._hasChangesSubscription.unsubscribe();
        }
        if (this._selectedUserSubscription) {
            this._selectedUserSubscription.unsubscribe();
        }
        if (this._pendingChangesActionSubscription) {
            this._pendingChangesActionSubscription.unsubscribe();
        }
        if (this._initialCustomCalendarSubscription) {
            this._initialCustomCalendarSubscription.unsubscribe();
        }
        if (this._customCalendarSubscription) {
            this._customCalendarSubscription.unsubscribe();
        }
        this._store.dispatch(new ResetState());
        this._store.dispatch(new ResetProperties());
    }

    ngOnInit() {
        this._pendingChangesValidationAction();
    }

    save() {
      if(this._baseCalendar.idWorkingTimeSchema) {
        this._store.dispatch(new UpdateBaseCalendarUser(this.selectedUser.idUser, this._baseCalendar.idWorkingTimeSchema));
      }

      this._store.dispatch(new UpdateCustomCalendar());
    }

    cancel() {
        this._store.dispatch(new RequestPendingChanges());
    }

    resetChanges() {
        this._store.dispatch(new SetBaseCalendarUser(this._initialBaseCalendar));
        this._store.dispatch(new SetCustomCalendar(this._initialCustomUserCalendar));
    }

    dialogPendingChanges() {
        this.modalRef = this._modalService.open(SavePendingChangesComponent, {closeOnRouterNavigation: true});
        this.modalRef.afterClosed().subscribe(result => {
            switch (result.action) {
                case 'dontsave':
                    this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.DONTSAVE));
                    this.modalRef.close();
                    break;
                case 'save':
                    this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.SAVE));
                    this.modalRef.close();
                    break;
                default:
                    this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.CANCEL));
                    this.modalRef.close();
                    break;
            }
            this._store.dispatch(new RequestPendingChangesDone());
        });
    }

    private _pendingChangesValidationAction() {
        this._pendingChangesActionSubscription = this._store
          .pipe(select(selectPendingChangeAction))
          .subscribe((action: EPendingChangesSelectedAction) => {
            switch (action) {
              case EPendingChangesSelectedAction.SAVE:
                this.save();
                break;
            }
          });
    }
}
